<div class="cancel-container mt-3">
  <span class="cancel-changes-text" [innerHTML]="formattedText"></span>
  <span class="cancel-changes" (click)="handleCancel()">
    <img src="assets/images/ponto-digital/CancelOutlined.png" alt="Cancelar alterações"> 
    Cancelar mudanças
  </span>
</div>

